import { ResourceDetails } from '../common';

export enum Ec2Action {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type Ec2ActionType =
  | Ec2Action.START
  | Ec2Action.STOP
  | Ec2Action.RESTART;

export enum Ec2State {
  PENDING = 'pending',
  RUNNING = 'running',
  SHUTTING_DOWN = 'shutting-down',
  STOPPED = 'stopped',
  STOPPING = 'stopping',
  TERMINATED = 'terminated',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface Ec2ResourceDetails extends ResourceDetails {
  state: Ec2State;
  type: string;
}
